import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

/**
 * Tema claro / escuro — apenas alterna a classe `theme-dark` no <html>.
 * As CORES são definidas pelo GlobalStyle (variáveis CSS). Aqui NÃO há
 * nenhum filtro/inversão — só o controle de estado e persistência.
 */

const STORAGE_KEY = 'x-escolar-theme';

const applyThemeClass = (theme) => {
    const root = document.documentElement;
    if (theme === 'dark') root.classList.add('theme-dark');
    else root.classList.remove('theme-dark');
};

const readSavedTheme = () => {
    try {
        return localStorage.getItem(STORAGE_KEY) || 'light';
    } catch (e) {
        return 'light';
    }
};

const ThemeContext = createContext({
    theme: 'light',
    toggleTheme: () => {},
    setTheme: () => {},
});

export const ThemeProvider = ({ children }) => {
    const [theme, setThemeState] = useState(() => {
        const saved = readSavedTheme();
        if (typeof document !== 'undefined') applyThemeClass(saved);
        return saved;
    });

    useEffect(() => {
        applyThemeClass(theme);
        try {
            localStorage.setItem(STORAGE_KEY, theme);
        } catch (e) {
            // storage indisponível: ignora
        }
    }, [theme]);

    const setTheme = useCallback((value) => {
        setThemeState(value === 'dark' ? 'dark' : 'light');
    }, []);

    const toggleTheme = useCallback(() => {
        setThemeState(prev => (prev === 'dark' ? 'light' : 'dark'));
    }, []);

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme, setTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);

export default ThemeContext;